export const getCollectionV2QueryKey = {
  all: ['collection/v2'],
  asset_id: () => [...getCollectionV2QueryKey.all, 'asset_id'],
  asset_param: params => [...getCollectionV2QueryKey.asset_id(), { ...params }],
};
